export const blurActiveElement = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
};

export const dismissKeyboardAndResetScroll = () => {
  blurActiveElement();
  window.scrollTo(0, 0);
};
